import { createContext } from 'react';
const NavigationContext = /*#__PURE__*/createContext({});
export default NavigationContext;